import { type ApolloError, gql, useQuery } from '@apollo/client';

import type { MaDeal } from '@/types/GraphqlSchema';

export const MA_DEALS_QUERY = gql`
  query maDeals($filters: MaFilters, $pagination: PaginationInput) {
    maDeals(filters: $filters, pagination: $pagination) {
      totalCount
      deals {
        id
        dealType
        comment
        effectiveDate

        dealBuyerCompanyName
        dealSellerCompanyName
        dealAssetName
        dealCountryName
        dealRegionName
      }
    }
  }
`;

type UseGetDealsProps = {
  filters: {
    eventTypes?: string[];
    countries?: string[];
    buyers?: number[];
    sellers?: number[];
    assets?: number[];
  };
  page: number;
  perPage: number;
  order?: 'asc' | 'desc' | undefined | null;
  orderBy?: string | undefined | null;
};

type UseGetDealsReturn = {
  deals: MaDeal[];
  totalCount: number;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetDeals = ({
  filters,
  page,
  perPage,
  order,
  orderBy,
}: UseGetDealsProps): UseGetDealsReturn => {
  const pagination = {
    page: page + 1,
    perPage,
    order,
    orderBy,
  };

  const { data, loading, error, previousData } = useQuery(MA_DEALS_QUERY, {
    variables: { filters, pagination },
  });

  const deals = data?.maDeals?.deals || previousData?.maDeals?.deals || [];
  const totalCount = data?.maDeals?.totalCount ?? previousData?.maDeals?.totalCount ?? 0;

  return {
    deals,
    totalCount,
    loading,
    error,
  };
};
